import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  TextField,
} from "@mui/material";
import { CrewSelector } from "@/shared/selectors/CrewSelector";
import type { StrandAsset } from "../../models/StrandAsset";
import { StrandLossCategoryAutocomplete } from "../modals/StrandLossCategoryAutocomplete";
import { StrandLossCodeTreePicker } from "../modals/StrandLossCodeTreePicker";
import { MinMinutesFilter } from "./MinMinutesFilter";
import { StrandSelector } from "./StrandSelector";

interface StrandLossesManagerFiltersProps {
  parentAssetId: number | null;
  strands: StrandAsset[];
  strandLossCodeId: number | null;
  strandLossCategoryId: number | null;
  strand: number | null;
  crew: string | null;
  minMinutes: number | null;
  quickFilter: string;
  showMicrolosses: boolean;
  onStrandLossCodeChange: (value: number | null) => void;
  onStrandLossCategoryChange: (value: number | null) => void;
  onStrandChange: (value: number | null) => void;
  onCrewChange: (value: string | null) => void;
  onMinMinutesChange: (value: number | null) => void;
  onQuickFilterChange: (value: string) => void;
  onShowMicrolossesChange: (value: boolean) => void;
}

export const StrandLossesManagerFilters = ({
  parentAssetId,
  strands,
  strandLossCodeId,
  strandLossCategoryId,
  strand,
  crew,
  minMinutes,
  quickFilter,
  showMicrolosses,
  onStrandLossCodeChange,
  onStrandLossCategoryChange,
  onStrandChange,
  onCrewChange,
  onMinMinutesChange,
  onQuickFilterChange,
  onShowMicrolossesChange,
}: StrandLossesManagerFiltersProps) => (
  <>
    <Box
      sx={{
        flex: 2,
        minWidth: 180,
        "& .MuiFormControl-root > *": { backgroundColor: "transparent" },
      }}
    >
      <StrandLossCodeTreePicker
        value={strandLossCodeId}
        onChange={(value) => onStrandLossCodeChange(value)}
        parentAssetId={parentAssetId}
      />
    </Box>
    <Box sx={{ flex: 2, minWidth: 150 }}>
      <StrandLossCategoryAutocomplete
        value={strandLossCategoryId}
        onChange={onStrandLossCategoryChange}
        parentAssetId={parentAssetId}
      />
    </Box>
    <Box sx={{ flex: 1, minWidth: 90 }}>
      <StrandSelector
        value={strand}
        onChange={onStrandChange}
        strands={strands}
      />
    </Box>
    <Box sx={{ flex: 1, minWidth: 90 }}>
      <CrewSelector value={crew} onChange={onCrewChange} />
    </Box>
    <Box sx={{ flex: 1, minWidth: 120 }}>
      <MinMinutesFilter value={minMinutes} onChange={onMinMinutesChange} />
    </Box>
    <Box sx={{ flex: 1.5, minWidth: 140 }}>
      <TextField
        label="Search"
        variant="outlined"
        size="small"
        fullWidth
        value={quickFilter}
        onChange={(event) => onQuickFilterChange(event.target.value)}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          },
        }}
      />
    </Box>
    <Box sx={{ flexShrink: 0 }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={showMicrolosses}
            color="primary"
            onChange={(event) => onShowMicrolossesChange(event.target.checked)}
          />
        }
        label="Microlosses"
      />
    </Box>
  </>
);
